import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { BreadCrumbs } from "../../../shared/breadCrumbs/BreadCrumbs";
import { useNavigate } from "react-router";
import { Link, useLocation } from "react-router-dom";
import { AssetDropDown } from "../../../UiComponents/AssetDropDown";
import { getAsset } from "../../../actions/assetAction";
import { getAssestListddlAction } from "../../../actions/assetsddlAction";
import { getAssetSettings } from "../../../actions/assetSettingsAction";
import { UrlPath } from "../../../../config/routeConfig";
import { Holdings } from "./Holdings";
import { TopBar } from "../../../shared/topBar/TopBar";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

import { ChartFilters, ChartWidgets } from "./Charts";
import { SecurityLookup } from "./SecurityLookup";
import { Overlap } from "./Overlap";

export const PublicExposure = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const history = useNavigate();
  const [render, setRender] = useState(true);
  const [Loading, setLoading] = useState(true);
  const locationData = useLocation();
  useEffect(() => {
    document.title = `Public Exposure`;
 },[])
  useEffect(() => {
    dispatch(getAssestListddlAction());
    dispatch(getAsset(params.Asset));
    dispatch(getAssetSettings(params.Asset));
  }, [render]);

  const Gstate =
    useSelector((state) => {
      return state;
    }) || {};

  useEffect(() => {
    currentAsset && AssetListDDL && setLoading(false);
  }, [Gstate]);

  const AssetListDDL = Gstate.assetDDL.assetList || [];

  const currentAsset = Gstate.asset.asset || {};

  let Level = [{ BreadCrumb: "Asset >", Routes: `${UrlPath.Asset}` }];
  Level = Loading
    ? Level
    : [
        ...Level,
        {
          BreadCrumb: `${currentAsset?.AssetName} >`,
          Routes: `${UrlPath.PublicExposure}${params.Asset}`,
        },
        {
          BreadCrumb: `Public Exposure`,
          Routes: `${UrlPath.PrivateExposure}${params.Asset}`,
        },
      ];

  const previouslyActiveTab =
    locationData.state === null ? "Holdings" : locationData.state.ActiveTab;

  return (
    <div>
      <TopBar label={"Public Exposure"} />
      <div id="content" class="asset-detail-screen">
      <BreadCrumbs Levels={Level} />
        <div class="p-4">   
          <Tabs
            defaultActiveKey={previouslyActiveTab}
            id="uncontrolled-tab-example"
            className="ms-3"
          >
            <Tab eventKey="Holdings" title="Holdings">
              <div class="p-3 bg-white life-science rounded">
                <div className="row m-0" style={{ margintop: "-5px" }}>
                  <div class="col-lg-12 px-0">
                    <Holdings></Holdings>
                  </div>
                </div>
              </div>
            </Tab>
            <Tab eventKey="Charts" title="Charts">
              <div class="p-3 bg-white life-science rounded">
                <ChartFilters AssetParams={currentAsset}/>
              </div>
              {/* <div className="row m-0">
                <div class="col-lg-9 px-0">
                  <ChartWidgets />
                </div>
              </div> */}
            </Tab>
            <Tab eventKey="SecurityLookup" title="Security Lookup">
              <div className="p-3 bg-white life-science rounded">
                <SecurityLookup />
              </div>
            </Tab>
            <Tab eventKey="Overlap" title="Overlap">
              <div class="p-3 bg-white life-science rounded">
                <Overlap />
              </div>
            </Tab>
            

          </Tabs>
        </div>
      </div>
    </div>
  );
};
